import { tokens } from '@/lib/auth/tokens'

export type WsMessage = {
  target_user_id?: string
  event: string
  data?: unknown
}

type Listener = (event: WsMessage) => void

let socket: WebSocket | null = null
const listeners = new Set<Listener>()
let reconnectTimer: ReturnType<typeof setTimeout> | null = null
let generation = 0

function wsUrl(token: string) {
  const configured = (import.meta.env.VITE_WS_URL as string | undefined)?.replace(/\/$/, '')
  if (configured) return `${configured}/ws?token=${encodeURIComponent(token)}`
  const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
  return `${proto}//${window.location.host}/ws?token=${encodeURIComponent(token)}`
}

function mine(msg: WsMessage) {
  return !msg.target_user_id || msg.target_user_id === tokens.userId
}

export function connectWs() {
  const token = tokens.access
  if (!token) return
  if (socket && (socket.readyState === WebSocket.OPEN || socket.readyState === WebSocket.CONNECTING)) return
  const gen = ++generation
  socket?.close()
  socket = new WebSocket(wsUrl(token))
  socket.onmessage = (ev) => {
    for (const line of String(ev.data).split('\n')) {
      if (!line.trim()) continue
      try {
        const msg = JSON.parse(line) as WsMessage
        if (!msg.event || !mine(msg)) continue
        listeners.forEach((fn) => fn(msg))
      } catch {
        /* bozuk çerçeve */
      }
    }
  }
  socket.onclose = () => {
    if (gen !== generation) return
    socket = null
    if (!tokens.access) return
    if (reconnectTimer) clearTimeout(reconnectTimer)
    reconnectTimer = setTimeout(() => connectWs(), 3000)
  }
}

export function disconnectWs() {
  generation += 1
  if (reconnectTimer) clearTimeout(reconnectTimer)
  reconnectTimer = null
  socket?.close()
  socket = null
}

export function reconnectWs() {
  disconnectWs()
  connectWs()
}

export function onWsEvent(fn: Listener) {
  listeners.add(fn)
  return () => {
    listeners.delete(fn)
  }
}
